import { useEffect, useState } from 'react';

/**
 * Hook to handle responsive layout changes
 * @param breakpoint The breakpoint for compact layout (default: 768)
 * @returns The isCompact state
 */
export const useResponsiveLayout = (breakpoint = 768) => {
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsCompact(window.innerWidth < breakpoint);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, [breakpoint]);

  return { isCompact };
};
